import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { VirtualLinkProvider } from '../types.js'

interface Props {
  provider: VirtualLinkProvider
  className?: string
}

export const VirtualLinkIcon = ({ className, provider }: Props) => {
  switch (provider) {
    case VirtualLinkProvider.Custom:
      return <SvgIcon name="link" className={className} />
    case VirtualLinkProvider.Meet:
      return <GoogleMeetIcon className={className} />
    case VirtualLinkProvider.Zoom:
      return <ZoomIcon className={className} />
    case VirtualLinkProvider.Youtube:
      return <YoutubeIcon className={className} />
    case VirtualLinkProvider.Teams:
      return <TeamsIcon className={className} />
    default:
      return <SvgIcon name="link" className={className} />
  }
}

const GoogleMeetIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 -22.5 256 256"
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid"
    >
      <g>
        <polygon
          fill="#00832D"
          points="144.822496 105.321856 169.778926 133.848796 203.341343 155.294133 209.178931 105.50196 203.341343 56.8331137 169.136495 75.6715889"
        ></polygon>
        <path
          d="M0.000557021739,150.659712 L0.000557021739,193.089915 C0.000557021739,202.77838 7.86384724,210.643527 17.5541688,210.643527 L59.9843714,210.643527 L68.7704609,178.585069 L59.9843714,150.659712 L30.8744153,141.873623 L0.000557021739,150.659712 Z"
          fill="#0066DA"
        ></path>
        <polygon
          fill="#E94235"
          points="59.9838143 9.9475983e-14 0 59.9838143 30.875715 68.7494798 59.9838143 59.9838143 68.6102243 32.4390893"
        ></polygon>
        <polygon
          fill="#2684FC"
          points="0.000557021739 150.679394 59.9843714 150.679394 59.9843714 59.9832573 0.000557021739 59.9832573"
        ></polygon>
        <path
          d="M241.658683,25.3977775 L203.341157,56.8342278 L203.341157,155.29339 L241.818362,186.852385 C247.577967,191.364261 256.003849,187.251584 256.003849,179.930462 L256.003849,32.1785888 C256.003849,24.7757699 247.377439,20.6835169 241.658683,25.3977775"
          fill="#00AC47"
        ></path>
        <path
          d="M144.822496,105.321856 L144.822496,150.659712 L59.9843714,150.659712 L59.9843714,210.643527 L185.787731,210.643527 C195.478053,210.643527 203.341343,202.77838 203.341343,193.089915 L203.341343,155.294133 L144.822496,105.321856 Z"
          fill="#00AC47"
        ></path>
        <path
          d="M185.787731,0 L59.9843714,0 L59.9843714,59.9838143 L144.822496,59.9838143 L144.822496,105.32167 L203.341343,56.832928 L203.341343,17.5536117 C203.341343,7.86329022 195.478053,0 185.787731,0"
          fill="#FFBA00"
        ></path>
      </g>
    </svg>
  )
}

const ZoomIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      className={className}
      fill="none"
      id="zoom"
    >
      <path
        fill="#2D8CFF"
        d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m38.087 15.935-6.783 4.949v6.251l6.783 4.949c.48.366 1.043.48 1.043-.521V16.456c0-.892-.452-1.004-1.043-.52ZM8.347 27.757v-11.27c0-.46.378-.835.843-.835h16.435c2.56 0 4.636 2.056 4.636 4.591v11.27a.839.839 0 0 1-.842.835H12.983c-2.559 0-4.635-2.056-4.635-4.591Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

const YoutubeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="141.801"
      height="99.59"
      viewBox="0 0 141.801 99.59"
      id="youtube"
      className={className}
    >
      <path
        fill="#fff"
        d="M94.457 48.344c-13-6.948-25.451-13.336-38.176-20v39.889c13.391-7.279 27.505-13.946 38.231-19.892h-.055Z"
      ></path>
      <path
        fill="#e8e0e0"
        d="M94.457 48.344c-13-6.948-38.176-20-38.176-20l33.564 22.554s-6.114 3.391 4.612-2.555Z"
      ></path>
      <path
        fill="#cd201f"
        d="M58.732 99.466c-27.005-.5-36.229-.944-41.9-2.113a18.417 18.417 0 0 1-9.613-5c-1.889-1.892-3.391-4.778-4.557-8.782-1-3.336-1.389-6.111-1.944-12.891-.85-15.3-1.052-27.81 0-41.788.866-7.716 1.287-16.88 7.053-22.226a18.917 18.917 0 0 1 9.447-4.778C22.774.833 46.446-.001 70.953-.001c24.451 0 48.176.834 53.737 1.889a18.486 18.486 0 0 1 11.057 6.556c5.262 8.277 5.354 18.568 5.888 26.619.221 3.836.221 25.616 0 29.452-.831 12.723-1.5 17.224-3.389 21.891a16.138 16.138 0 0 1-3.891 6.225 18.639 18.639 0 0 1-9.892 5.056c-23.37 1.757-43.214 2.139-65.736 1.778Zm35.783-51.122c-13-6.948-25.451-13.391-38.176-20.06v39.9c13.393-7.28 27.508-13.95 38.231-19.895l-.055.055Z"
      ></path>
    </svg>
  )
}

const TeamsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="207"
      height="175"
      viewBox="0 0 207 175"
      id="teams"
      className={className}
    >
      <defs>
        <filter
          id="i"
          width="102.7%"
          height="102.4%"
          x="-1.4%"
          y="-1.2%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dx="-1"
            in="SourceAlpha"
            result="shadowOffsetInner1"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner1"
            result="shadowMatrixInner1"
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.19 0"
          ></feColorMatrix>
          <feOffset
            dx="1"
            in="SourceAlpha"
            result="shadowOffsetInner2"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner2"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner2"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner2"
            result="shadowMatrixInner2"
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.17 0"
          ></feColorMatrix>
          <feOffset
            dx="2"
            dy="1"
            in="SourceAlpha"
            result="shadowOffsetInner3"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner3"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner3"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner3"
            result="shadowMatrixInner3"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.01 0"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixInner1"></feMergeNode>
            <feMergeNode in="shadowMatrixInner2"></feMergeNode>
            <feMergeNode in="shadowMatrixInner3"></feMergeNode>
          </feMerge>
        </filter>
        <filter
          id="l"
          width="105%"
          height="105%"
          x="-2.5%"
          y="-2.5%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dx="-1"
            in="SourceAlpha"
            result="shadowOffsetInner1"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner1"
            result="shadowMatrixInner1"
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.19 0"
          ></feColorMatrix>
          <feOffset
            dx="1"
            in="SourceAlpha"
            result="shadowOffsetInner2"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner2"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner2"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner2"
            result="shadowMatrixInner2"
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.17 0"
          ></feColorMatrix>
          <feOffset
            dx="2"
            dy="1"
            in="SourceAlpha"
            result="shadowOffsetInner3"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner3"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner3"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner3"
            result="shadowMatrixInner3"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.01 0"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixInner1"></feMergeNode>
            <feMergeNode in="shadowMatrixInner2"></feMergeNode>
            <feMergeNode in="shadowMatrixInner3"></feMergeNode>
          </feMerge>
        </filter>
        <filter
          id="p"
          width="102.1%"
          height="101.9%"
          x="-1%"
          y="-.9%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur
            in="SourceAlpha"
            result="shadowBlurInner1"
            stdDeviation=".5"
          ></feGaussianBlur>
          <feOffset
            dx="-1"
            dy="-1"
            in="shadowBlurInner1"
            result="shadowOffsetInner1"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner1"
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.17 0"
          ></feColorMatrix>
        </filter>
        <filter
          id="t"
          width="103.6%"
          height="103.6%"
          x="-1.8%"
          y="-1.8%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur
            in="SourceAlpha"
            result="shadowBlurInner1"
            stdDeviation=".5"
          ></feGaussianBlur>
          <feOffset
            dx="-1"
            dy="-1"
            in="shadowBlurInner1"
            result="shadowOffsetInner1"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner1"
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.27 0"
          ></feColorMatrix>
        </filter>
        <filter
          id="z"
          width="103.1%"
          height="103.1%"
          x="-1.6%"
          y="-1.5%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur
            in="SourceAlpha"
            result="shadowBlurInner1"
            stdDeviation=".5"
          ></feGaussianBlur>
          <feOffset
            dx="-1"
            in="shadowBlurInner1"
            result="shadowOffsetInner1"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner1"
            result="shadowMatrixInner1"
            values="0 0 0 0 0.215686275   0 0 0 0 0.270588235   0 0 0 0 0.698039216  0 0 0 1 0"
          ></feColorMatrix>
          <feGaussianBlur
            in="SourceAlpha"
            result="shadowBlurInner2"
            stdDeviation=".5"
          ></feGaussianBlur>
          <feOffset
            dx="2"
            in="shadowBlurInner2"
            result="shadowOffsetInner2"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner2"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner2"
          ></feComposite>
          <feColorMatrix
            in="shadowInnerInner2"
            result="shadowMatrixInner2"
            values="0 0 0 0 0.211764706   0 0 0 0 0.247058824   0 0 0 0 0.588235294  0 0 0 1 0"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixInner1"></feMergeNode>
            <feMergeNode in="shadowMatrixInner2"></feMergeNode>
          </feMerge>
        </filter>
        <filter
          id="B"
          width="148.8%"
          height="138.8%"
          x="-24.4%"
          y="-17.3%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dy="1"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="3"
          ></feGaussianBlur>
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
          ></feColorMatrix>
          <feOffset
            dy="1"
            in="SourceAlpha"
            result="shadowOffsetOuter2"
          ></feOffset>
          <feGaussianBlur
            in="shadowOffsetOuter2"
            result="shadowBlurOuter2"
            stdDeviation=".5"
          ></feGaussianBlur>
          <feColorMatrix
            in="shadowBlurOuter2"
            result="shadowMatrixOuter2"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
          </feMerge>
        </filter>
        <filter
          id="E"
          width="117%"
          height="117%"
          x="-8.5%"
          y="-8.5%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="3"></feGaussianBlur>
        </filter>
        <linearGradient id="f" x1="103.648%" x2="4.41%" y1="100%" y2="3.534%">
          <stop offset="0%" stopColor="#4B5DE9"></stop>
          <stop offset="100%" stopColor="#3941C3"></stop>
        </linearGradient>
        <linearGradient
          id="m"
          x1="37.071%"
          x2="84.489%"
          y1="38.816%"
          y2="89.984%"
        >
          <stop offset="0%" stopColor="#505CDF"></stop>
          <stop offset="100%" stopColor="#7E93FF"></stop>
        </linearGradient>
        <linearGradient id="q" x1="19.27%" x2="95.313%" y1="10.369%" y2="100%">
          <stop offset="0%" stopColor="#414FB7"></stop>
          <stop offset="100%" stopColor="#5260D9"></stop>
        </linearGradient>
        <linearGradient
          id="v"
          x1="2.151%"
          x2="113.177%"
          y1="9.713%"
          y2="104.673%"
        >
          <stop offset="0%" stopColor="#1D2771"></stop>
          <stop offset="100%" stopColor="#2D38A5"></stop>
        </linearGradient>
        <linearGradient id="D" x1="29.468%" x2="97.963%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#F0F0F0"></stop>
          <stop offset="100%" stopColor="#FFF"></stop>
        </linearGradient>
        <pattern
          id="h"
          width="512"
          height="512"
          x="-512"
          y="-460"
          patternUnits="userSpaceOnUse"
        >
          <use xlinkHref="#a"></use>
        </pattern>
        <pattern
          id="k"
          width="512"
          height="512"
          x="-487"
          y="-512"
          patternUnits="userSpaceOnUse"
        >
          <use xlinkHref="#b"></use>
        </pattern>
        <pattern
          id="o"
          width="512"
          height="512"
          x="-512"
          y="-444"
          patternUnits="userSpaceOnUse"
        >
          <use xlinkHref="#c"></use>
        </pattern>
        <pattern
          id="s"
          width="512"
          height="512"
          x="-492"
          y="-512"
          patternUnits="userSpaceOnUse"
        >
          <use xlinkHref="#d"></use>
        </pattern>
        <pattern
          id="x"
          width="512"
          height="512"
          x="-512"
          y="-512"
          patternUnits="userSpaceOnUse"
        >
          <use xlinkHref="#e"></use>
        </pattern>
        <circle id="j" cx="45" cy="20" r="20"></circle>
        <circle id="r" cx="48" cy="28" r="28"></circle>
        <rect id="u" width="96" height="96" rx="8"></rect>
        <rect id="A" width="96" height="98" y="-1" rx="8"></rect>
        <path
          id="g"
          d="M0.0995199027,95.2654288 C0.0340203685,94.8532592 0,94.4306026 0,94 L0,60 C0,55.581722 3.581722,52 8,52 L66,52 C70.418278,52 74,55.581722 74,60 L74,94 C74,94.4306026 73.9659796,94.8532592 73.9004801,95.2654288 C73.9664408,96.1683426 74,97.0802522 74,98 C74,118.434536 57.4345357,135 37,135 C16.5654643,135 0,118.434536 0,98 C0,97.0802522 0.0335591976,96.1683426 0.0995199027,95.2654288 Z"
        ></path>
        <path
          id="n"
          d="M0.0206311615,125.578993 C0.00695535871,125.387776 2.38439235e-17,125.1947 0,125 L0,76 C-5.41083001e-16,71.581722 3.581722,68 8,68 L88,68 C92.418278,68 96,71.581722 96,76 L96,125 C96,125.1947 95.9930446,125.387776 95.9793688,125.578993 C95.9930913,126.050985 96,126.524686 96,127 C96,153.509668 74.509668,175 48,175 C21.490332,175 0,153.509668 0,127 C0,126.524686 0.00690870053,126.050985 0.0206311615,125.578993 Z"
        ></path>
        <radialGradient
          id="w"
          cx="86.601%"
          cy="84.21%"
          r="60.992%"
          fx="86.601%"
          fy="84.21%"
        >
          <stop offset="0%" stopColor="#313DAE"></stop>
          <stop offset="100%" stopColor="#313DAE" stopOpacity="0"></stop>
        </radialGradient>
        <polygon
          id="C"
          points="67.965 30.989 52.985 30.989 52.985 72.014 43.911 72.014 43.911 30.989 29 30.989 29 23 67.965 23"
        ></polygon>
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(6)">
        <g transform="translate(9)">
          <g transform="translate(53)">
            <g transform="translate(65 16)">
              <use xlinkHref="#g" fill="url(#f)"></use>
              <use xlinkHref="#g" fill="url(#h)" fillOpacity=".012"></use>
              <use xlinkHref="#g" fill="#000" filter="url(#i)"></use>
              <g>
                <use xlinkHref="#j" fill="url(#f)"></use>
                <use xlinkHref="#j" fill="url(#k)" fillOpacity=".012"></use>
                <use xlinkHref="#j" fill="#000" filter="url(#l)"></use>
              </g>
            </g>
            <use xlinkHref="#n" fill="url(#m)"></use>
            <use xlinkHref="#n" fill="url(#o)" fillOpacity=".012"></use>
            <use xlinkHref="#n" fill="#000" filter="url(#p)"></use>
            <g>
              <use xlinkHref="#r" fill="url(#q)"></use>
              <use xlinkHref="#r" fill="url(#s)" fillOpacity=".012"></use>
              <use xlinkHref="#r" fill="#000" filter="url(#t)"></use>
            </g>
          </g>
          <path d="M53.0206312,125.578993 C53.0069554,125.387776 53,125.1947 53,125 L53,76 C53,71.581722 56.581722,68 61,68 L141,68 C145.418278,68 149,71.581722 149,76 L149,125 C149,125.1947 148.993045,125.387776 148.979369,125.578993 C148.993091,126.050985 149,126.524686 149,127 C149,153.509668 127.509668,175 101,175 C74.490332,175 53,153.509668 53,127 C53,126.524686 53.0069087,126.050985 53.0206312,125.578993 Z M101,56 C85.536027,56 73,43.463973 73,28 C73,12.536027 85.536027,0 101,0 C116.463973,0 129,12.536027 129,28 C129,43.463973 116.463973,56 101,56 Z"></path>
          <g transform="translate(0 39)">
            <mask id="y" fill="#fff">
              <use xlinkHref="#u"></use>
            </mask>
            <use xlinkHref="#u" fill="url(#v)"></use>
            <use xlinkHref="#u" fill="url(#w)"></use>
            <use xlinkHref="#u" fill="url(#x)" fillOpacity=".013"></use>
            <g fill="#000" mask="url(#y)">
              <use xlinkHref="#A" filter="url(#z)"></use>
            </g>
            <g mask="url(#y)">
              <use xlinkHref="#C" fill="#000" filter="url(#B)"></use>
              <use xlinkHref="#C" fill="url(#D)"></use>
            </g>
          </g>
        </g>
        <path
          fill="#000"
          fillOpacity=".05"
          d="M18,39 L98,39 C102.418278,39 106,42.581722 106,47 L106,127 C106,131.418278 92.418278,145 88,145 L8,145 C3.581722,145 5.41083001e-16,141.418278 0,137 L0,57 C-5.41083001e-16,52.581722 13.581722,39 18,39 Z"
          filter="url(#E)"
        ></path>
      </g>
    </svg>
  )
}
